import { FaPaperPlane } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { InstallationPickerRow } from "../installation/InstallationPickerSheet";

const NotificationCharacterizeAction = ({
  toCharacterization,
  onCharacterize,
  disabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className="installation-settings-card notification-characterize-action-card">
      <InstallationPickerRow
        icon={FaPaperPlane}
        iconVariant="photo-capture"
        title={t("To characterize")}
        subtitle={
          toCharacterization
            ? t("characterizationAlreadyRequested")
            : t("mobile_qualicheck_characterize_hint")
        }
        placeholder={t("mobile_qualicheck_characterize_hint")}
        onClick={() => {
          if (!toCharacterization && !disabled) {
            onCharacterize?.();
          }
        }}
        disabled={toCharacterization || disabled}
      />
    </div>
  );
};

export default NotificationCharacterizeAction;
